import Debugger from "../console/debugger";
import EventBus from "../event_bus";
import AppRenderer from "../../js/app_renderer";
import BookData from "../../js/book_data";
import { examStore } from "../store/examStore";
import { store } from "@/store";

export default class ExamTool {
    _lessonExamSelector = null;
    _lessonExamTip = null;

    constructor(lessonExamSelector, lessonExamTip) {
        this._lessonExamSelector = lessonExamSelector;
        this._lessonExamTip = lessonExamTip;
    }

    getToolFunction() {
        return [
            {
                // 即時測驗平臺
                key: "online_exam",
                event: () => {
                    AppRenderer.Instance.openWebSite("https://digitalmaster.knsh.com.tw/test/quiz/index.html");
                }
            },
            {
                //隨堂測驗
                key: "lesson_exam",
                event: this.openLessonExam()
            }
        ]
    }

    openLessonExam() {
        Debugger.Instance.log("lesson_exam", "exam_tool");

        return () => {
            examStore.setExamKey(`${store.nowBook}_${store.nowPage}`);

            if (!examStore.hasExam()) {
                this._lessonExamTip.showTip();
                return;
            }

            this._lessonExamSelector.show = true;
        }
    }
}